/**
 * Tham số của trang Sổ album ngoài đơn trên đường dẫn (/albums/ledger?month=2026-10&branch=hn_01):
 * gửi link sổ cho người khác là họ thấy đúng tháng, đúng cơ sở.
 */

export type LedgerSearch = {
  /** NNNN-TT; vắng = tháng này. */
  month?: string;
  branch?: string;
  /**
   * Lọc trạng thái trên màn (máy chủ trả đủ). `unattached` = chưa gắn khách (QĐ 0308);
   * `retouch` = có chuyển hậu kỳ, `self` = có lần tự duyệt (QĐ 0309).
   */
  status?: "active" | "trash" | "purged" | "unattached" | "retouch" | "self";
};

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

export function parseLedgerSearch(raw: Record<string, unknown>): LedgerSearch {
  const out: LedgerSearch = {};
  const month = typeof raw["month"] === "string" ? raw["month"].trim() : "";
  if (MONTH.test(month)) out.month = month;
  const branch = typeof raw["branch"] === "string" ? raw["branch"].trim() : "";
  if (branch) out.branch = branch;
  const status = raw["status"];
  if (
    status === "active" ||
    status === "trash" ||
    status === "purged" ||
    status === "unattached" ||
    status === "retouch" ||
    status === "self"
  )
    out.status = status;
  return out;
}
